import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useRef } from 'react';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/defineProperty';
import { isEqual, isFunction } from 'lodash';

var defaultPropUpdateOnChange = function defaultPropUpdateOnChange(prop) {
  return prop;
};

function defaultShouldUpdate(_ref) {
  var prop = _ref.prop,
      prevProp = _ref.prevProp,
      stateValue = _ref.stateValue;
  return !isEqual(prop, prevProp) && !isEqual(prop, stateValue);
}

function setStateWithUpdate(onUpdate, setState) {
  return function (state) {
    setState(function (prevState) {
      return onUpdate(isFunction(state) ? state(prevState) : state, prevState);
    });
  };
}

function useDerivedStateFromProp(prop) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$onUpdate = options.onUpdate,
      onUpdate = _options$onUpdate === void 0 ? defaultPropUpdateOnChange : _options$onUpdate,
      _options$shouldUpdate = options.shouldUpdate,
      shouldUpdate = _options$shouldUpdate === void 0 ? defaultShouldUpdate : _options$shouldUpdate,
      _options$updateOnStat = options.updateOnStateChange,
      updateOnStateChange = _options$updateOnStat === void 0 ? false : _options$updateOnStat;

  var _useState = useState(onUpdate(prop, {})),
      _useState2 = _slicedToArray(_useState, 2),
      stateValue = _useState2[0],
      setState = _useState2[1];

  var handleSetState = updateOnStateChange ? setStateWithUpdate(onUpdate, setState) : setState;
  var prevProp = useRef(prop);

  if (shouldUpdate({
    prop: prop,
    prevProp: prevProp.current,
    stateValue: stateValue
  })) {
    var nextProp = onUpdate(prop, prevProp.current);
    setState(nextProp);
  }

  prevProp.current = prop;
  return [stateValue, handleSetState];
}

export default useDerivedStateFromProp;
//# sourceMappingURL=useDerivedStateFromProps.js.map
